<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="12"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100vh">
        <grid-row class="justify-content-center h-100">
            <grid-col col="6" tablet="12">
                <div class="font-400 font-size-24px  color-base-700 mt-30">
                    {{"BenefitsDocuments" | translate }}
                </div>
                <div class="font-400 font-size-14px color-base-1200 mt-30">
                    {{"DOCUMENTS" | translate }}
                </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-15 p-16" *ngFor="let D of this.BenefitsDoc">
                    <grid-row class="align-item-center justify-content-between">
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-600">
                                <!-- {{"PolicyCertificate" | translate}} --> {{D.desc_eng}}
                            </div>
                        </grid-col>
                        <grid-col col="auto" (click)="ViewPDF(D.srvc)">
                            <div
                                class="br-100px border border-color-ddd pt-8 pb-8 pr-16 pl-16 font-size-12px font-600 link" >
                                {{"VIEWPDF" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
                <!-- <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-15 p-16">
                    <grid-row class="align-item-center justify-content-between">
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-600">
                                {{"PolicySchedule" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div
                                class="br-100px border border-color-ddd pt-8 pb-8 pr-16 pl-16 font-size-12px font-600 link">
                                {{"VIEWPDF" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-15 p-16">
                    <grid-row class="align-item-center justify-content-between">
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-600">
                                {{"TaxInvoice" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div
                                class="br-100px border border-color-ddd pt-8 pb-8 pr-16 pl-16 font-size-12px font-600 link">
                                {{"VIEWPDF" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-15 p-16">
                    <grid-row class="align-item-center justify-content-between">
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-600">
                                {{"InsuranceQuotation" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div
                                class="br-100px border border-color-ddd pt-8 pb-8 pr-16 pl-16 font-size-12px font-600 link">
                                {{"VIEWPDF" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </div> -->
                <div class="font-400 font-size-14px color-base-1200 mt-30">
                    {{"BENEFITS" | translate }}
                </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-15 p-16" *ngFor="let B of this.Benefits; let i = index; ">
                    <div class="custom-accordion" [ngClass]="this.accordionItem == i ? 'active':''">
                        <div class="custom-accordion-heading" (click)="showAccordion(i)">
                            <div class="font-size-14px font-600 color-base-600">
                                <!-- {{ "GoldPlus" | translate }} --> {{B.coverName}}
                            </div>
                        </div>
                        <ng-container *ngIf="this.accordionItem == i">
                            <div class="custom-accordion-content" *ngFor="let b of B.benefits; let i = index; ">
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    <!-- {{"ThirdPartyLiabilityCover" | translate}} -->{{b.benefitDetail}}
                                </div>
                                <!-- <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"Coverageforaccidental" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"Coverageintheevent" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"PerilsofNaturecover" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"Premiumratewill" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"hoursroadassistance" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"PickupandDelivery" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"RiotsStrikes" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"DaysCarReplacement" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                                    {{"YearsAgencyRepair" | translate}}
                                </div>
                                <div class="font-400 font-size-13px color-base-1400 pt-10 pb-10">
                                    {{"Depreciation" | translate}}
                                </div> -->
                            </div>
                        </ng-container>
                    </div>
                </div>
                <!-- <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-15 p-16">
                    <div class="custom-accordion" [ngClass]="this.accordionItem == 2 ? 'active':''">
                        <div class="custom-accordion-heading" (click)="showAccordion(2)">
                            <div class="font-size-14px font-600 color-base-600">
                                {{ "SmallSedan" | translate }}
                            </div>
                        </div>
                        <ng-container *ngIf="this.accordionItem == 2">
                            <div class="custom-accordion-content">
                            </div>
                        </ng-container>
                    </div>
                </div> -->
                
            </grid-col>
        </grid-row>
    </div>
</div>